import {createSlice} from '@reduxjs/toolkit';

const slice = createSlice({
    name: 'growthStatictis',
    initialState: {
        isRequesting: false,
        error: null,
        data: {},
        searchCriteria:{}
    },
    reducers: {
        get_growth_statistic: (state,action) => {
            return {
                ...state,
                isRequesting: true,
                error: null,
                searchCriteria:{...action.payload}
            };
        },
        get_growth_statistic_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                data: action.payload,
            };
        },
        get_growth_statistic_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload.error,
                data: {}
            };
        }
    }
});

export const {reducer, actions} = slice;

export default reducer;